module.exports = __webpack_public_path__ + "static/logo-dove-764b7a55d80473d2f86e90a3f735f2e0.svg";